<!-- <div class="loader"></div> -->
<i class="fad fa-circle-notch fa-spin spinner"></i>
<p class="t-a-c color-dark-grey">{{loadingText}} ...</p>